import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'currencySymbol',
    pure: true,
    standalone: false
})
export class CurrencySymbolPipe implements PipeTransform {
  transform(symbol: string | null | undefined): string {
    if (!symbol) {
      return '$';
    }

    const normalized = symbol.trim().toLowerCase();
    if (normalized.startsWith('usdc') || normalized === 'usdt') {
      return '$';
    }

    return symbol;
  }
}
